import React from "react"
import { NotFound } from "../conponents"



export const NotFoundPage = () => <NotFound />
